export enum EnumTipoLoteLiquidacion {
  Facturacion = 1,
  Emision = 2,
  FacturacionAutomatica = 3,
  EmisionAutomatica = 4,
  Validacion = 5,
  Eliminacion = 6,
  Anulacion = 7,
  Refacturacion = 8,
  FacturacionSinObjeciones = 9,
  EmisionSinObjeciones = 10,
  Repintado = 11
}
